import { addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'

export default function () {
  addLocaleData([...en])
}
